import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalooService } from './baloo.service';
import { FormsModule } from '@angular/forms';
import { BalooEditContainerComponent } from './baloo-edit-container/baloo-edit-container.component';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { UIRouterModule } from '@uirouter/angular';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { BalooStates } from '@fi-app/external-platform-integration/baloo/baloo-states';
import { BalooSettingsComponent } from './baloo-settings/baloo-settings.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatButtonModule } from '@angular/material/button';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { BalooMatchModule } from '@fi-app/external-platform-integration/baloo/baloo-match/baloo-match.module';
import { BalooManualSyncModule } from '@fi-app/external-platform-integration/baloo/baloo-manual-sync/baloo-manual-sync.module';
import { BalooSyncLogModule } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log.module';
import { BalooHelperService } from '@fi-app/external-platform-integration/baloo/baloo-helper.service';
import { MatDividerModule } from '@angular/material/divider';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiButtonBackNewModule,
        FiTabsModule,
        UIRouterModule.forChild(BalooStates),
        FiAppTextSharedModule,
        SelectSearchModule,
        MatButtonModule,
        FiWhenScrolledModule,
        FiWrapperTableModule,
        MatCardModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        FiPrintDownloadModule,
        BalooManualSyncModule,
        BalooSyncLogModule,
        BalooMatchModule,
        MatDividerModule,
        FiToggleSwitchModule,
    ],
    declarations: [BalooEditContainerComponent, BalooSettingsComponent],
    providers: [BalooService, BalooHelperService],
})
export class BalooModule {}
